import '..//styles/App.css';

import '@aws-amplify/ui-react/styles.css';
import { useAuth } from "react-oidc-context";



const Interface = () => {
    const auth = useAuth();

    return (
        <div className="unauthenticated-container">
            <h1 className="heading">Welcome to the AEC Transcription Service</h1>
                <p className="description">
                    Please sign in to access your old files, upload files, and continue conversations. 
                </p>
                <div className="button-container">
                <button className="auth-button" onClick={auth.signinRedirect}>
                    Sign In
                </button>
            </div>
        </div>
        
        
      
    );
  };

export default Interface;